import { clientConfig } from '@/config/clientConfig';

/**
 * Cognito CustomMessage Lambda key for the active brand. The Lambda (separate
 * repo: skewbdigital/cognito-presign-lambda) keys logos, subjects, and body
 * copy off this exact PascalCase string — kebab-case or unknown values fall
 * through to the Ignite Core defaults and a broken logo.
 */
export function getCognitoAppName(): string {
  switch (clientConfig.id) {
    case 'yorkshire-water':
      return 'SkewbWorksLiteYW';
    case 'works-lite':
    default:
      return 'SkewbWorksLite';
  }
}
